// <input type="datetime-local"> speaks local wall-clock time with no zone;
// the API speaks ISO. These convert between the two.

export const toLocalInputValue = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const fromLocalInputValue = (value) => {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
};

// max= attribute so the picker itself blocks future times (BE rejects them too)
export const nowLocalInputValue = () => toLocalInputValue(new Date().toISOString());
